/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';

/**
 * 
 * @export
 * @interface CompanyMetaDataLLM
 */
export interface CompanyMetaDataLLM {
    /**
     * 
     * @type {string}
     * @memberof CompanyMetaDataLLM
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyMetaDataLLM
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CompanyMetaDataLLM
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompanyMetaDataLLM
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetaDataLLM
     */
    companyId?: string;
    /**
     * 
     * @type {Company}
     * @memberof CompanyMetaDataLLM
     */
    company?: Company;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetaDataLLM
     */
    descriptionEN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetaDataLLM
     */
    descriptionNL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetaDataLLM
     */
    categoryEN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetaDataLLM
     */
    categoryNL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetaDataLLM
     */
    rawQueryData?: string | null;
}

/**
 * Check if a given object implements the CompanyMetaDataLLM interface.
 */
export function instanceOfCompanyMetaDataLLM(value: object): value is CompanyMetaDataLLM {
    return true;
}

export function CompanyMetaDataLLMFromJSON(json: any): CompanyMetaDataLLM {
    return CompanyMetaDataLLMFromJSONTyped(json, false);
}

export function CompanyMetaDataLLMFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyMetaDataLLM {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'company': json['company'] == null ? undefined : CompanyFromJSON(json['company']),
        'descriptionEN': json['descriptionEN'] == null ? undefined : json['descriptionEN'],
        'descriptionNL': json['descriptionNL'] == null ? undefined : json['descriptionNL'],
        'categoryEN': json['categoryEN'] == null ? undefined : json['categoryEN'],
        'categoryNL': json['categoryNL'] == null ? undefined : json['categoryNL'],
        'rawQueryData': json['rawQueryData'] == null ? undefined : json['rawQueryData'],
    };
}

export function CompanyMetaDataLLMToJSON(json: any): CompanyMetaDataLLM {
    return CompanyMetaDataLLMToJSONTyped(json, false);
}

export function CompanyMetaDataLLMToJSONTyped(value?: CompanyMetaDataLLM | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'companyId': value['companyId'],
        'company': CompanyToJSON(value['company']),
        'descriptionEN': value['descriptionEN'],
        'descriptionNL': value['descriptionNL'],
        'categoryEN': value['categoryEN'],
        'categoryNL': value['categoryNL'],
        'rawQueryData': value['rawQueryData'],
    };
}

